/* Blue Collar Apparel — interacciones (vanilla, sin librerías) */
(function () {
  "use strict";

  /* ===== Reveals al hacer scroll ===== */
  function initReveals() {
    var els = document.querySelectorAll(".bc-reveal, .bc-reveal-img");
    if (!els.length) return;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      els.forEach(function (el) { el.classList.add("bc-in"); });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add("bc-in");
            io.unobserve(e.target);
          }
        });
      },
      { rootMargin: "0px 0px -10% 0px", threshold: 0.05 }
    );
    els.forEach(function (el) { io.observe(el); });
  }

  /* ===== Página de producto: variantes + galería ===== */
  function initProduct() {
    var root = document.querySelector("[data-bc-product]");
    if (!root) return;

    var dataEl = root.querySelector("[data-bc-variants]");
    var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
    var priceEl = root.querySelector("[data-bc-price]");
    var idInput = root.querySelector('input[name="id"]');
    var atc = root.querySelector("[data-bc-atc]");
    var atcLabel = atc ? atc.getAttribute("data-label-add") : "";
    var atcSoldout = atc ? atc.getAttribute("data-label-soldout") : "";
    var money = function (cents) {
      return "$" + (cents / 100).toFixed(2);
    };

    function selectedOptions() {
      var opts = [];
      root.querySelectorAll("[data-bc-option]").forEach(function (group) {
        var active = group.querySelector(".bc-pill.bc-active");
        opts.push(active ? active.getAttribute("data-value") : null);
      });
      return opts;
    }

    function findVariant(opts) {
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }

    function update() {
      var v = findVariant(selectedOptions());
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price);
      if (atc) {
        if (v.available) {
          atc.disabled = false;
          atc.textContent = atcLabel;
        } else {
          atc.disabled = true;
          atc.textContent = atcSoldout;
        }
      }
      if (v.featured_image) swapMain(v.featured_image);
    }

    root.querySelectorAll("[data-bc-option]").forEach(function (group) {
      group.querySelectorAll(".bc-pill").forEach(function (pill) {
        pill.addEventListener("click", function () {
          group.querySelectorAll(".bc-pill").forEach(function (p) { p.classList.remove("bc-active"); });
          pill.classList.add("bc-active");
          update();
        });
      });
    });

    /* Galería */
    var main = root.querySelector("[data-bc-main] img");
    function swapMain(src) {
      if (!main || !src) return;
      main.src = src;
      root.querySelectorAll("[data-bc-thumb]").forEach(function (t) {
        t.classList.toggle("bc-active", t.getAttribute("data-src") === src);
      });
    }
    root.querySelectorAll("[data-bc-thumb]").forEach(function (t) {
      t.addEventListener("click", function () { swapMain(t.getAttribute("data-src")); });
    });

    update();
  }

  document.addEventListener("DOMContentLoaded", function () {
    initReveals();
    initProduct();
  });
})();
